import AddonTypeCard from "./AddonTypeCard";
import {CgWebsite} from "react-icons/cg";
import {PiUserSquareFill} from "react-icons/pi";
import {useContext, useEffect, useState} from "react";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import DiscountCard, {ActiveDiscountCard} from "./DiscountCard";
import discount from "../../tools/api/finCheck/discount";
import deleteDiscount from "../../tools/api/finCheck/deleteDiscount";
import LoadingScreen from "../LoadingScreen";
import preConfirmDiscount from "../../tools/api/authentication/preConfirmDiscount";

const defaults = [

    {
        icon: <CgWebsite className="text-gray-500 text-5xl "/>,
        title: 'افزودن روی این آگهی',
        description: 'با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار خواهد گرفت.',
        type: 'postAddon',

    },
    {
        icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
        title: 'افزودن روی حساب کاربری',
        description: <span className="text-gray-700 text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما به مدت سه ماه اضافه
            خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</span>,
        type: 'userAddon',

    }
];
const ChooseAddonType = ({onConfirm, addonType = "postAddon"}) => {
    const [discountPreLoading, setDiscountPreLoading] = useState(true);
    const [discountLoading, setDiscountLoading] = useState(false);
    const [discountError, setDiscountError] = useState(null);
    const [deleteDiscountLoading, setDeleteDiscountLoading] = useState(false);
    const [deleteDiscountError, setDeleteDiscountError] = useState(null);
    const finCheckContext = useContext(FinCheckContext);
    const [type, setType] = useState(addonType);
    useEffect(async () => {
        if (localStorage.getItem('discount_code') && finCheckContext.pid) {
            const params = {
                pid: finCheckContext.pid,
                code: localStorage.getItem('discount_code'),
            }
            const response = await discount(finCheckContext.token, params);
            const {hasError} = response;
            setDiscountPreLoading(false);
            localStorage.removeItem('discount_code')
            if (!hasError) {
                finCheckContext.handleFetchProcess(finCheckContext.pid);
            }
        } else {
            setDiscountPreLoading(false)
        }
    }, []);
    const onSelect = (type) => {
        setType(type)
    }
    const handleConfirm = () => {
        onConfirm(type)
    }
    const handleDiscount = async (discountCode, showError = true) => {

        try {
            setDiscountLoading(true)
            const data = {
                "pid": finCheckContext.pid,
                "code": discountCode
            }
            const response = await discount(finCheckContext.token, data);
            setDiscountLoading(false)
            const {hasError, message} = response;
            if (hasError && showError) {
                setDiscountError(message)
            } else {
                await finCheckContext?.handleFetchProcess(finCheckContext.pid)
            }
        } catch {
            setDiscountError('خطا سرویس. لطفا مجددا تلاش کنید.')
        }

    }

    const handleDeleteDiscount = async () => {
        try {
            setDeleteDiscountLoading(true)
            const params = {
                "pid": finCheckContext.pid,

            }
            const response = await deleteDiscount(finCheckContext.token, params);
            setDeleteDiscountLoading(false)
            const {hasError, message} = response;
            if (hasError) {

                setDeleteDiscountError(message)
            } else {
                setDiscountError(null)
                setDeleteDiscountError(null)
                await finCheckContext?.handleFetchProcess(finCheckContext.pid)
            }
        } catch {
            setDiscountError('خطا سرویس. لطفا مجددا تلاش کنید.')
        }
    }
    if (discountPreLoading) {
        return <LoadingScreen/>
    }
    return <div className="w-full bg-gray-100 pt-5 min-h-screen">
        <div className="flex flex-col items-center justify-center">
            <h1 className="text-center font-bold   text-xl">
                خوش حسابی ونیفای
            </h1>
            <p className="text-sm mb-4 mt-1 ">لطفا نوع افزونه خود را انتخاب کنید.</p>
        </div>
        <div className="grid grid-cols-1 gap-6">
            {defaults.map((item, index) => (
                <AddonTypeCard isSelected={type === item.type} key={item.type + finCheckContext.process.discount}
                               data={item} onSelect={onSelect}/>
            ))}
        </div>
        <div className="w-full mt-4">
            {!finCheckContext.process.discount &&
                <DiscountCard loading={discountLoading} errorMessage={discountError} onConfirm={handleDiscount}/>}
            {finCheckContext.process.discount &&
                <ActiveDiscountCard error={deleteDiscountError} loading={deleteDiscountLoading} canDelete={true}
                                    onDelete={handleDeleteDiscount}
                                    code={finCheckContext.process.discount?.code}/>}

        </div>
        <BottomButtonWrapper>

            <Button onClick={handleConfirm} rounded="rounded-lg" className="text-sm" theme="green">مرحله بعد</Button>
        </BottomButtonWrapper>
    </div>
}
export default ChooseAddonType